import React, { useEffect, useState } from 'react'
import Header from '../Core/Header'
import { doctors } from '../../Assets/dummyDoc'
import { getAllDoctor } from '../../service/operations/api_methods'
import { useSelector } from 'react-redux'
import { baseURLImg } from '../../service/api_endpoints'

const ViewDoctors = () => {
    const[list,setList]=useState(doctors)
     const token=useSelector((state)=>state?.auth?.token)

    const [doctorsList,setDoctorsList]=useState([])

       const handleGetAlldoctors=async()=>{
            try {
                const res =await getAllDoctor(token)
                console.log('getAllDoctor',res.data.data);
                if(res.status===200){
                    let l=res.data.data.filter(i=>i.alreadyMapped===true)
                    setDoctorsList(l)
                }
                
            } catch (error) {
              console.log(error);
                
            }
         }

    

             useEffect(() => {
                handleGetAlldoctors()
              }, [])
         
  return (
    <div style={{height:"100vh",width:"100%"}}>
      <Header/>
      <section style={{marginTop:"80px",height:"calc(100vh - 80px)",background: "linear-gradient(180deg, #555454ff, #ffffffff, #5f5f5fff)",padding:"20px"}}>
        <div style={{fontSize:"24px",fontWeight:"700",textAlign:"center",display:"flex",justifyContent:"space-around",padding:"6px"}}>
            <p style={{color:"white"}}>All Doctors of this Hospital</p>
            <input placeholder='Search Doctor by name'
            style={{border:"0.5px solid white",
                borderRadius:"8px",
                fontSize:"16px",padding:"5px",
                backgroundColor:"white"
            }}/>
            </div>
        <div style={{height:"calc(100vh - 100px)",display:"flex",flexWrap:"wrap",width:"100%",overflowY:"auto",overflowX:"hidden"}}>
            {
            doctorsList.map((item)=>(
                <div style={{width:"22vw",minHeight:"40vh",maxHeight:"fit-content",borderRadius:"10px",padding:"10px",backgroundColor:"#c5c4c4ff",
                    display:"flex",flexDirection:"column",alignItems:"center",margin:"10px"
                }}>
                     <img src={`${baseURLImg}${item?.user?.profile_image}`} style={{height:"70%",width:"85%",borderRadius:"10px"}}/>
                                        <div style={{display:"flex",flexDirection:"column",alignItems:"start",width:"90%"}}>
                                            <p style={{fontSize:"20px",textAlign:"left",fontWeight:"500"}}>{item?.user?.first_name}  {item?.user?.last_name}</p>
                                            <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#d65d3eff"}}>D.o.b:{item?.user?.dob}</span>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#6fa0d8ff"}}>{item?.user?.email}</span></p>
                                                <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#d65d3eff"}}>Ph:{item?.user?.primary_number}</span>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#6fa0d8ff"}}>Specialist:{item?.specialist_type}</span></p>
                                            <p style={{width:"100%",display:"flex",justifyContent:"space-between"}}>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#a3343aff"}}>Exp:{item?.experience_years}</span>
                                                <span style={{fontSize:'12px',fontWeight:"500",color:"#5456d6ff"}}>Med.Id:{item?.user?.medical_id}</span></p>
                                        
                                            
                                         </div>

                    </div>
            ))
            }

        </div>

      </section>
    </div>
  )
}

export default ViewDoctors
